import { createFileRoute, redirect } from "@tanstack/react-router";
import { Helmet } from "react-helmet-async";
import nookies from "nookies";
import { ErrorElement } from "~/components/ErrorElement";

import { DashboardUsaha } from "~/features/dashboard-usaha";

export const Route = createFileRoute("/_layout/dashboard-usaha/")({
  beforeLoad: () => {
    const isLogin = nookies.get().token !== undefined;

    if (!isLogin) {
      throw redirect({
        to: "/",
      });
    }
  },

  component: () => (
    <>
      <Helmet>
        <title>Dashboard Usaha - Ecobiz</title>
      </Helmet>
      <DashboardUsaha />
    </>
  ),
  errorComponent: () => <ErrorElement statusCode="500" />,
  notFoundComponent: () => <ErrorElement statusCode="404" />,
});
